import { MINUTES } from "@/model/Settings";
import { currentRoute } from "@/router/navigation";

import { refreshTokenGuarded } from "./http/api.config";
import { identityChanged } from "./sessionIdentity";

const MIN_INTERVAL_MS = 2 * MINUTES;
// Module-scoped: lives only for this page load. An SPA-only relogin (the logout
// page's `login()` branch navigates via the router rather than reloading)
// intentionally keeps this state — it is not reset on relogin, and that's fine.
let lastAttempt = 0;

/**
 * A role denial for an RPC call arrives as the generated NoSuccessError with
 * code "FORBIDDEN_ERROR", and a pubsub role denial as ForbiddenPublisherError;
 * neither reaches here. A NATS PermissionsViolation instead means the cookie
 * and the running scheme disagree (the company's flag flipped) or a genuine
 * deny-list hit. Refresh once, reload only if the identity moved;
 * otherwise hand back to the caller's existing handling.
 */
export async function handlePermissionsViolation(fallback: () => void): Promise<void> {
  if (Date.now() - lastAttempt < MIN_INTERVAL_MS) {
    fallback();
    return;
  }
  lastAttempt = Date.now();
  try {
    const response = await refreshTokenGuarded({ path: "#" + currentRoute().fullPath });
    // refreshToken() already reloaded through reloadIfIdentityChanged
    if (await identityChanged(response)) {
      return;
    }
  } catch (_) {
    // a failed refresh cannot fix the grants either
  }
  fallback();
}
